// tslint:disable:component-selector
import {
  Component,
  ComponentFactoryResolver,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ViewEncapsulation,
  AfterViewInit,
  AfterContentInit,
  OnInit
} from '@angular/core';
//
// Library
//
import * as Library from '../../../../core/library/index';
import { Guid } from '../../../../core/common/guid';
//
// Models
//
import { Action } from '../../../../core/common/action';
//
// Directives
//
import { RtiAnchorDirective } from '../../../directive/common/rti-anchor.directive';
//
// Entry Components
//
import { RtiLeaseCard } from '../rti-lease-card/rti-lease-card';
import { RtiCashCard } from '../rti-cash-card/rti-cash-card';
import { RtiAprCard } from '../rti-apr-card/rti-apr-card';
import { RtiDiscountCard } from '../rti-discount-card/rti-discount-card';

@Component({
  selector: 'rti-local-special-card',
  templateUrl: './rti-local-special-card.html',
  styleUrls: ['./rti-local-special-card.scss'],
  encapsulation: ViewEncapsulation.None,
  entryComponents: [RtiLeaseCard, RtiCashCard, RtiAprCard, RtiDiscountCard]
})
export class RtiLocalSpecialCard
  implements OnInit {
  @Input() data: any;
  @Input() hidden: boolean;
  @Input() disabled: boolean;
  @Input() actions: Action[];
  // tslint:disable-next-line
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  //
  // View Children
  //
  @ViewChild(RtiAnchorDirective) anchor: RtiAnchorDirective;

  public cid: string;

  //
  // onCard()
  //
  public onCard($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    if (Library.isDefined(this.onClick)) {
      this.onClick.emit({
        event: $event,
        cid: this.cid
      });
    }
  }

  public ngOnInit() {
    //
    // If the card type is defined
    //
    if (Library.isObject(this.data)) {
      //
      // Dynamically Create an Instance of a Component of Type<T>
      //
      const componentRef = this.anchor.view.createComponent(
        this._componentFactoryResolver.resolveComponentFactory(this.data.type)
      );
      //
      // Assign Data to ComponentRef Instance
      // multi select dropdown
      //
      if (Library.isDefined(componentRef)) {
        componentRef.instance['data'] = this.data;
      }
    }
  }

  /**
   * constructor()
   */
  constructor(private _componentFactoryResolver: ComponentFactoryResolver) {
    this.cid = Guid.NEW();
    this.actions = [];
    this.data = {};
    this.hidden = false;
    this.disabled = false;
  }
}
